
import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  }
});
